import {HOMEAWAY, VRBO, CTA_LINK_HOMEAWAY,
    CTA_LINK_VRBO, CTA_BUTTON_TEXT, HOMEAWAY_SITE} from '../banner-defaults';

function getBrandName(travelerApp) {
    return travelerApp && travelerApp.toLowerCase() === HOMEAWAY.toLowerCase() ? HOMEAWAY : VRBO;
}

function getDownloadLinkBase(brandName) {
    return brandName.toLowerCase() === HOMEAWAY.toLowerCase() ? CTA_LINK_HOMEAWAY : CTA_LINK_VRBO;
}

function getDownloadLink(ctaLink, brandName, hav, xdid) {
    const downloadLinkBase = ctaLink ? ctaLink : getDownloadLinkBase(brandName);
    return `${downloadLinkBase}?hav=${hav}&source_visitor_id=${hav}&source_xdid=${xdid}`;
}

function getImgUrl(site) {
    return `https://csvcus.homeaway.com/rsrcs/cdn-logos/4.6.3/sitename/${site.toLocaleLowerCase()}/web/app-icon-rounded.png`;
}

function getSite(brandName) {
    return brandName === VRBO ? VRBO : HOMEAWAY_SITE;
}

function getButtonLabel(label) {
    return label ? label : CTA_BUTTON_TEXT;
}

export {
    getBrandName,
    getDownloadLinkBase,
    getDownloadLink,
    getImgUrl,
    getSite,
    getButtonLabel
};
